import { render, staticRenderFns } from "./FormFlagList.vue?vue&type=template&id=646f23b8&scoped=true&"
import script from "./FormFlagList.vue?vue&type=script&lang=js&"
export * from "./FormFlagList.vue?vue&type=script&lang=js&"
import style0 from "./FormFlagList.vue?vue&type=style&index=0&id=646f23b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646f23b8",
  null
  
)

export default component.exports